import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OrganizationFacilitiesResponse } from '../types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FacilitiesListService {
  private readonly _http = inject(HttpClient);

  getFacilities(
    facilitiesURL: string,
    params: HttpParams,
  ): Observable<OrganizationFacilitiesResponse> {
    return this._http.get<OrganizationFacilitiesResponse>(facilitiesURL, {
      params: params,
    });
  }
}
